import React, { createContext, Dispatch, useState, SetStateAction } from 'react';

import { User, AppContextType } from "../types";

export const AppContext = createContext({} as AppContextType);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function AppProvider({ children }: any) {
    const [usuario, setUsuario] = useState<User>({} as User);
    const [menus, setMenus] = useState<any>({} as any);
    return (
        <AppContext.Provider value={{
            usuario,
            setUsuario,
            menus,
            setMenus,
        }}>
            {children}
        </AppContext.Provider>
    );
}